import { type ForwardedRef, forwardRef } from 'react';

import { getSourceEventParams, useAmplitude } from '@crehana/analytics';
import { LearningAvailableContentsWidget } from '@crehana/compass.dashlets';

import { useCentralizedOrganization } from '@/shared/hooks/use-centralized-organization';

import { useLearningAvailableContents } from '../hooks/use-learning-available-contents';

type TLearningAvailableContentsWidgetProps = {
  organizationSlug: string;
  dataTestId?: string;
};

export const LearningAvailableContentsWidgetComponent = forwardRef<
  HTMLDivElement,
  TLearningAvailableContentsWidgetProps
>(({ organizationSlug, dataTestId }, ref: ForwardedRef<HTMLDivElement>) => {
  const { logEvent } = useAmplitude();
  useCentralizedOrganization(organizationSlug);

  const { contents, loading, error, refetch } = useLearningAvailableContents({
    first: 5,
  });

  const onClickGoToCatalog = () => {
    logEvent({
      event: 'Go To Catalog Clicked',
      data: {
        ...getSourceEventParams(),
        Organization: organizationSlug,
      },
    });
    window.open(
      `/org/${organizationSlug}/learn/content`,
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <div ref={ref} data-testid={dataTestId} className="tw-w-full tw-h-full">
      <LearningAvailableContentsWidget
        listContents={contents}
        onClickGoToCatalog={onClickGoToCatalog}
        isCatalogEnabled={true}
        orgName={organizationSlug}
        isLoading={loading}
        isError={!!error}
        onRetry={refetch}
      />
    </div>
  );
});

LearningAvailableContentsWidgetComponent.displayName =
  'LearningAvailableContentsWidgetComponent';
